import QuantityActionTypes from '../actionTypes/QuantityActionTypes';

const setSelectedQuantity = (quantity, sourceMiniPDP) => ({
    type: QuantityActionTypes.QUANTITY_ON_CHANGE,
    payload: quantity,
    sourceMiniPDP,
});

const resetQuantityActions = () => ({
    type: QuantityActionTypes.QUANTITY_RESET,
    sourceMiniPDP: true,
});

export default {
    setSelectedQuantity,
    resetQuantityActions,
};
